package kz.dentalcrm.app.screens.positions.list.mvi

import kz.dentalcrm.app.core.base.ViewEvent
import kz.dentalcrm.app.data.network.response_model.positions.Position

sealed interface PositionsViewEvent : ViewEvent {
    data class Search(val query: String) : PositionsViewEvent
    data object Reload : PositionsViewEvent
    data class EditPosition(val position: Position) : PositionsViewEvent
    data class DeletePosition(val id: Int) : PositionsViewEvent
}
